import React, { useState } from "react"
import { graphql, Link } from "gatsby"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { Map, Marker } from "../components/Map"
import nl2br from "../utils/nl2br"
import { cities } from "../config"
import DesktopOnboarding from "../components/Onboarding/desktop"
import RetinaImageWrapper from "../components/RetinaImage"
import OnboardingMobile from "../components/OnboardingMobile"

import "./index.less"

export const mapCenter = {
  toronto: {
    lat: 43.658856,
    lng: -79.3849863,
  },
  kitchener: {
    lat: 43.4539503,
    lng: -80.4993533,
  },
}

export default ({ data }) => {
  const locations = data.cms.locations
  const pageData = data.cms.pageData
  const solutions = data.cms.solutions

  const [city, setCity] = useState(cities[0])

  return (
    <Layout covidAlert>
      <SEO
        title={pageData?.metaTitle}
        description={pageData?.metaDescription}
        image={
          pageData?.metaImage?.[0]
            ? pageData?.metaImage[0].url
            : pageData?.coverImage[0].url
        }
        jsonSchema={pageData?.jsonSchema}
      />
      <div className="container cover-section">
        <div className="cover-section">
          <div className="images single-image">
            {/* Mobile on-boarding component */}
            {/*<Onboarding title={pageData.pageTitle} className={"d-xl-none"} />*/}
            <OnboardingMobile
              title={pageData.pageTitle}
              className={"d-xl-none"}
            />

            <DesktopOnboarding title={pageData.pageTitle} />

            {pageData.coverImage.length > 0 && (
              <img alt={"Hero Image"} src={pageData.coverImageRetina[0]?.url} />
            )}
          </div>
        </div>
      </div>

      <section className="home-intro-section">
        <div className="container">
          <div className="inner">
            <div className="row">
              <div className="col-md-6 d-flex align-items-center">
                <h2>{nl2br(pageData.introSectionTitle)}</h2>
              </div>
              <div className="col-md-6 d-flex align-items-center">
                <p>{nl2br(pageData.introSectionText)}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Solutions solutions={solutions} />

      <section className="image-right">
        <div className="container">
          <div className="row">
            <div className="col-md-6 d-flex align-items-center">
              <div>
                <h2>{nl2br(pageData.section1Title)}</h2>
                <div className="img d-md-none">
                  <img
                    src={pageData.section1Image[0].url}
                    alt={pageData.section1Image[0].title}
                  />
                </div>
                <p>{nl2br(pageData.section1Text)}</p>
                <Link className={"btn btn-primary"} to={"/why-workplace-one"}>
                  Learn More
                </Link>
              </div>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <div className="img d-none d-md-block">
                <RetinaImageWrapper
                  image={pageData.section1Image[0]}
                  retinaImage={pageData.section1ImageRetina[0]}
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="home-clients">
        <div className="container">
          <div className="row">
            <div className="col-sm-12">
              <h2 className="text-center my-0">
                Trusted by the best companies
              </h2>
            </div>
            {pageData.companies.map(({ url, title }, idx) => (
              <div className="col-4 col-sm-4 col-md-2" key={idx}>
                <img
                  src={pageData.companiesRetina?.[idx]?.url || url}
                  alt={title}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="map-container">
        <div className="container d-flex align-items-center">
          <h2>Locations</h2>
          <Link
            className={"ms-auto btn btn-primary d-none d-sm-block"}
            to={"/locations"}
          >
            Explore All Locations
          </Link>
        </div>
        <div className="container">
          {cities.length > 1 &&
            cities.map((c) => (
              <button
                key={c}
                className={`btn switcher ${city === c ? "active" : ""}`}
                onClick={() => setCity(c)}
              >
                {c}
              </button>
            ))}

          <div className="home-page-map-container">
            <Map
              center={mapCenter[city.toLowerCase()]}
              defaultZoom={
                typeof window !== "undefined" && window.innerWidth > 768
                  ? 13
                  : 12.5
              }
            >
              {locations.length > 0 &&
                locations.map((item, idx) => {
                  if (item.location.parts.city !== city) {
                    return null
                  }
                  return (
                    <Marker
                      key={idx}
                      id={idx}
                      slug={`/locations/${item.slug}`}
                      text={item.title}
                      lat={item.location.lat}
                      lng={item.location.lng}
                    />
                  )
                })}
            </Map>
          </div>

          <Link className={"btn btn-primary d-sm-none"} to={"/locations"}>
            Explore All Locations
          </Link>
        </div>
      </section>
    </Layout>
  )
}

export const Solutions = ({ solutions }) => {
  return (
    <section className={"home-solutions-section"}>
      <div className="container d-flex align-items-center">
        <h2>Solutions</h2>
        <Link
          className={"ms-auto btn btn-primary d-none d-sm-block"}
          to={"/solutions"}
        >
          Explore Solutions
        </Link>
      </div>

      <div className="container">
        <div className="row custom-row">
          {solutions.map((item) => (
            <div key={item.id} className="col-6 col-lg-3">
              <div className={"home-solutions-block"}>
                <div className="image">
                  <RetinaImageWrapper
                    image={item.solutionImages[0]}
                    retinaImage={item.solutionImagesRetina[0]}
                  />
                </div>
                <h4>{item.title}</h4>
                <p>{item.solutionShortDescription}</p>
              </div>
            </div>
          ))}

          <div className="col-sm-12">
            <Link className={"btn btn-primary d-sm-none"} to={"/solutions"}>
              Explore Solutions
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}
export const query = graphql`
  query {
    cms {
      locations: entries(section: "locations") {
        id
        title
        slug
        ... on Cms_locations_locations_Entry {
          id
          location {
            address
            lat
            lng
            parts {
              city
            }
          }
        }
      }
      solutions: entries(section: "solutions", limit: 4) {
        id
        ... on Cms_solutions_solutions_Entry {
          id
          title
          solutionShortDescription
          solutionImages {
            url(width: 300, height: 180)
            title
          }
          solutionImagesRetina: solutionImages {
            url(width: 600, height: 360)
            title
          }
        }
      }
      pageData: entry(section: "homePage") {
        ... on Cms_homePage_homePage_Entry {
          id
          metaDescription
          metaTitle
          metaImage {
            url(width: 1200, height: 630)
          }
          jsonSchema
          section1Text
          section1Title
          sectionHandle
          pageTitle
          section1Image {
            url(width: 600, height: 400)
            title
          }
          section1ImageRetina: section1Image {
            url(width: 1200, height: 800)
            title
          }
          introSectionText
          introSectionTitle
          companies {
            url(width: 276, height: 150)
            title
          }
          companiesRetina: companies {
            url(width: 552, height: 300)
            title
          }
          coverImage {
            url(width: 1280, height: 720)
            title
          }
          coverImageRetina: coverImage {
            url(width: 2560, height: 1440)
            title
          }
        }
      }
    }
  }
`
